<template>
    <div class="pop_overlay_black" v-if="isShow" style="z-index:9999">
        <div class="pop_wrap pop_noti">
            <div v-if="isLoading" class="loading_bg transparent" style="z-index: 999;">
                <div class="loading_wrap">
                    <div class="loading_obj">
                        <svg class="spinner" width="60px" height="60px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                        </svg>
                    </div>
                </div>
            </div>
            <button  class="pop_noti_close" :disabled="isLoading" v-if="usingCloseButton" @click.stop="_action_Close">
                <v-icon>mdi-close</v-icon>
            </button>
            <div class="pop_noti_danger_wrap" v-if="usingAlertTag">
                <span class="pop_noti_danger"><v-icon class="red_txt">mdi-alert-circle</v-icon> {{ $t('common.label_danger_alert') }}</span>
            </div>
            <div class="cont">
                <pre>{{ title }}</pre>
            </div>
            <div class="pop_noti_btn_wrap">
                <button class="btn btn_s btn_gray" :disabled="isLoading" @click.stop="_action_Left">
                    {{ lButtonTitle }}
                </button>
                <button class="btn btn_s btn_blue" :disabled="isLoading" @click.stop="_action_Right">
                    {{ rButtonTitle }}
                </button>
            </div>
        </div>
    </div>
</template>


<script>
import { AlertPopupType, closeAlertPopup, sheetAlert } from '../../../sheet-alert'
export default {
    data() {
        return {
            sheetAlert,
            isLoading: false,
            type: undefined,
        }
    },
    computed: {
        types: function() {
            return AlertPopupType
        },
        isShow: function() {
            if (this.popup?.type == undefined) { return false }
            return this.popup?.type == this.type
        },
        popup: function() {
            return this.sheetAlert.popup
        },
        popupType: function() {
            return this.popup.type
        },
        usingAlertTag: function() {
            return this.popup.usingAlertTag
        },
        usingCloseButton: function() {
            return this.popup.usingCloseButton
        },
        title: function() {
            return this.popup.title
        },
        lButtonTitle: function() {
            return this.popup.lButtonTitle
        },
        rButtonTitle: function() {
            return this.popup.rButtonTitle
        },
        lHandler: function() {
            return this.popup.lHandler
        },
        rHandler: function() {
            return this.popup.rHandler
        },
        lParam: function() {
            return this.popup.lParam
        },
        rParam: function() {
            return this.popup.rParam
        },
        params: function() {
            return this.popup.params
        }
    },
    methods: {
        async _action_Left() {
            if (this.isLoading == true) { return }
            this.isLoading = true
            if (this.popup.lHandler != undefined) {
                await this.popup.lHandler(this.lParam)
            }
            this.isLoading = false
        },
        async _action_Right() {
            if (this.isLoading == true) { return }
            this.isLoading = true
            if (this.popup.rHandler != undefined) {
                await this.popup.rHandler(this.rParam)
            }
            this.isLoading = false
        },
        async _action_Close() {
            if (this.isLoading == true) { return }
            closeAlertPopup()
        }
    }
}
</script>